module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/level-ws/~/isarray/index.js
// module id = 1487
// module chunks = 0 1 2